const Footer = () => {
  return (
      <footer className="App-home-footer">
        Copyright &copy; brainyx.com 2022 
      </footer>
  );
}

export default Footer;